import { render, staticRenderFns } from "./PaymentMethodsEmpty.vue?vue&type=template&id=25c615a7&scoped=true&"
import script from "./PaymentMethodsEmpty.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsEmpty.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsEmpty.vue?vue&type=style&index=0&id=25c615a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c615a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
